import { render, staticRenderFns } from "./notify.vue?vue&type=template&id=3b386618&"
import script from "./notify.vue?vue&type=script&lang=js&"
export * from "./notify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b386618')) {
      api.createRecord('3b386618', component.options)
    } else {
      api.reload('3b386618', component.options)
    }
    module.hot.accept("./notify.vue?vue&type=template&id=3b386618&", function () {
      api.rerender('3b386618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/subBill/notify.vue"
export default component.exports